
import { Vue, Component } from 'vue-property-decorator';
import { getDetail } from '../api/index';
import VoteButton from '../components/VoteButton.vue';
import XGplayer from '@/components/XGplayer.vue';
import { Icon, Toast, Swipe, SwipeItem, Lazyload, ImagePreview } from 'vant';
import { namespace, State, Mutation } from 'vuex-class';
const fengShangModule = namespace('fengShang');
Vue.use(Icon)
  .use(Toast)
  .use(Swipe)
  .use(SwipeItem)
  .use(Lazyload);
@Component({
  components: {
    VoteButton,
    XGplayer,
  },
})
export default class Detail extends Vue {
  @fengShangModule.State('workType') workType: any;
  @fengShangModule.State('activityId') activityId: any;
  detail: any = {};
  async created() {
    try {
      Toast.loading({
        forbidClick: true,
        duration: 0,
      });
      const res: any = await getDetail(this.$route.query.id as string);
      this.detail = res.data;
      Toast.clear();
    } catch (error) {
      console.log(error);
    }
  }
  votSuccess(val: any) {
    window.location.reload();
    this.detail.votes = val.num;
  }
}
